export default __webpack_public_path__ + "static/media/step4.09e16a12.png";